import { useState } from 'react';
import guideMd from '../../docs/TECH_GUIDE.md?raw';
import Welcome from '../components/Welcome.jsx';
import { parseGuide, inlineSegments } from '../utils/guideMarkdown.js';
import { switchTech, firstName } from '../utils/identity.js';
import { readLocal, KEYS } from '../utils/storage.js';

// Help (D-LAUNCH1): replay the welcome, then the Field Guide — rendered from
// docs/TECH_GUIDE.md at build time so the doc and the app can't disagree.
const BLOCKS = parseGuide(guideMd);

function Inline({ text }) {
  return inlineSegments(text).map((s, i) => {
    if (s.bold) return <strong key={i} className="text-ink-50">{s.text}</strong>;
    if (s.italic) return <em key={i}>{s.text}</em>;
    return <span key={i}>{s.text}</span>;
  });
}

function Block({ block }) {
  switch (block.type) {
    case 'h1':
      return <h2 className="text-2xl font-bold text-ink-50"><Inline text={block.text} /></h2>;
    case 'h2':
      return <h3 className="text-xl font-bold text-ink-50 pt-4"><Inline text={block.text} /></h3>;
    case 'h3':
      return <h4 className="text-lg font-semibold text-ink-100 pt-2"><Inline text={block.text} /></h4>;
    case 'ul':
      return (
        <ul className="list-disc pl-6 space-y-2 text-ink-200 leading-relaxed">
          {block.items.map((item, i) => <li key={i}><Inline text={item} /></li>)}
        </ul>
      );
    default:
      return <p className="text-ink-200 leading-relaxed"><Inline text={block.text} /></p>;
  }
}

// Signing out of Google alone leaves the Cloudflare Access session (and
// therefore the previous tech's identity) live for up to 24h — see
// switchTech() in utils/identity.js. This confirms, then routes through
// Access's own logout on the signed-in path, or straight back to the name
// gate on the typed-name fallback.
function onSwitchTech() {
  if (window.confirm('Sign out so another tech can sign in?')) {
    switchTech();
  }
}

export default function Help() {
  const [replay, setReplay] = useState(false);
  return (
    <div className="px-5 py-6 max-w-3xl mx-auto space-y-6">
      <div className="card space-y-3">
        <h1 className="text-2xl font-bold text-ink-50">Help</h1>
        <p className="text-ink-300">
          Stuck, or something looks wrong? Tap <strong className="text-ink-50">Feedback</strong> at the top of any screen.
        </p>
        <button type="button" onClick={() => setReplay(true)} className="btn-secondary w-full">
          Replay the welcome
        </button>
        <button type="button" onClick={onSwitchTech} className="btn-secondary w-full">
          Switch tech
        </button>
      </div>
      <article className="card space-y-3">
        {BLOCKS.map((b, i) => <Block key={i} block={b} />)}
      </article>
      {replay && <Welcome name={firstName(readLocal(KEYS.techName, ''))} onDone={() => setReplay(false)} />}
    </div>
  );
}
